/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_End_All_LoggedInputs */

const en_us2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every set is logged.`)
};

const pt_br2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as séries estão registradas.`)
};

const es_419_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las series están registradas.`)
};

const pt_pt2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as séries estão registadas.`)
};

const fr_fr2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les séries sont enregistrées.`)
};

const de_de2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Sätze sind erfasst.`)
};

const it_it2_workout_after_end_all_logged = /** @type {(inputs: Workout_After_End_All_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le serie sono registrate.`)
};

/**
* | output |
* | --- |
* | "Every set is logged." |
*
* @param {Workout_After_End_All_LoggedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_all_logged = /** @type {((inputs?: Workout_After_End_All_LoggedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_All_LoggedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_all_logged(inputs)
	if (locale === "es-419") return es_419_workout_after_end_all_logged(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_all_logged(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_all_logged(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_all_logged(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_all_logged(inputs)
	return en_us2_workout_after_end_all_logged(inputs)
});
export { workout_after_end_all_logged as "workout-after.end_all_logged" }